module.exports = __webpack_public_path__ + "static/img/02.f37d091.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/contact/02.png
// module id = +qKp
// module chunks = 1